export const getConfirmName = (value: boolean) => {
  return value ? '済' : '';
};
